import { render, staticRenderFns } from "./BulkUpdate.vue?vue&type=template&id=6c0330e0&"
import script from "./BulkUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdate.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports